import { render, staticRenderFns } from "./TrademarkNoteType.vue?vue&type=template&id=6fc3cc40&"
import script from "./TrademarkNoteType.vue?vue&type=script&lang=js&"
export * from "./TrademarkNoteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports